import { render, staticRenderFns } from "./PracticeArea.vue?vue&type=template&id=570f75cb"
import script from "./PracticeArea.vue?vue&type=script&lang=js"
export * from "./PracticeArea.vue?vue&type=script&lang=js"
import style0 from "./PracticeArea.vue?vue&type=style&index=0&id=570f75cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports